import { SensorKitValidateSensorPlacementsCard } from "@/sync/SensorKitValidateSensorPlacementsCard";

export const SensorKitValidateSensorPlacementsPage = ({ sensorKitSerialNumber }: { sensorKitSerialNumber: string }) => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <SensorKitValidateSensorPlacementsCard sensorKitSerialNumber={sensorKitSerialNumber}/>
      </div>
    </div>
  )
}